import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  headerContainer: {
    marginTop: 10,
    textAlign: "center",
  },
  billTo: {
    marginTop: 10,
    paddingBottom: 3,
    fontFamily: "Helvetica-Oblique",
  },
  companyTitle: {
    fontWeight: 800,
    fontSize: 30,
  },
  ownerStyle: {
    fontSize: 15,
  },
});

const BillTo = ({ invoice }) => (
  <View style={styles.headerContainer}>
    <Text style={styles.companyTitle}>{invoice.company}</Text>
    <Text style={styles.ownerStyle}>{invoice.propitor}</Text>
    <Text style={styles.ownerStyle}>{invoice.director}</Text>
    <Text>{invoice.address}</Text>
  </View>
);

export default BillTo;
